import { get } from "services/actions";
import AppLayout from "components/AppLayout";
import RealizaPage from "components/pages/Realiza";
import strapiImg from "utils/strapiImg";

export default function Realiza({ appLayout, realizaPage }) {
  return (
    <AppLayout data={appLayout}>
      <RealizaPage data={realizaPage} />
    </AppLayout>
  );
}

export async function getStaticProps() {
  const header = await get("cabecalho");
  const footer = await get("rodape");
  const receiveNews = await get("receba-novidades");
  const data = await get("a-realiza");

  // DADOS AppLayout
  const appLayout = {
    header: {
      logo: strapiImg(header.logo, "", true),
      menu: header.menu,
    },
    footer: {
      logo: strapiImg(footer.logo, "", true),
      redes: footer.redes_sociais.map(({ id, nome, link, icone }) => {
        icone = strapiImg(icone, "", true);
        return {
          id,
          nome,
          link,
          icone,
        };
      }),
      unidades: footer.unidades,
      submenus: footer.submenu,
      whatsappIcon: strapiImg(footer?.icone_whatsapp_rodape, "", true),
      openChatBot: footer?.habilitar_chatbot
    },
  };

  // DADOS RealizaPage
  const realizaPage = {
    seo: {
      titulo: data.SEO.title,
      descricao: data.SEO.description,
      imagem: strapiImg(data.SEO.image, "", true),
    },
    banner: {
      titulo: data.titulo,
      chamada: data.banner_internas.titulo,
      imagem: strapiImg(data.banner_internas.banner, "", true),
    },
    proposito: {
      titulo: data.secao01.titulo,
      texto: data.secao01.texto,
      imagem: strapiImg(data.secao01.imagem, "", true),
    },
    vocacao: {
      titulo: data.secao02.titulo,
      texto: data.secao02.texto,
      imagem: strapiImg(data.secao02.imagem, "", true),
    },
    missaoCompromisso: {
      titulo: data.secao03.titulo,
      texto: data.secao03.texto,
      imagem: strapiImg(data.secao03.imagem, "", true),
    },
    secaoDestaques: {
      titulo: data.secao_destaque.titulo,
      chamada: data.secao_destaque.chamada,
      icones: data.secao_destaque.icones,
    },
    secaoRecebaNovidades: {
      imagem: strapiImg(receiveNews.background_imagem, "", true),
      email: receiveNews.email_de_envio,
    },
  };

  return {
    props: {
      appLayout,
      realizaPage,
    },
    revalidate: 60,
  };
}
